export default __webpack_public_path__ + "static/media/zoom.532ac2e8.svg";